export const HeartFilledIcon = () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 511.85 448.2"
  >
    <path
      fill="#ff2f40"
      d="M472.02,40.7C446.22,14.5,411.93.1,375.33.1s-70.8,14.4-96.7,40.5l-22.7,23-22.7-23C207.83,14.6,172.93,0,136.52,0S65.33,14.6,39.83,40.6c-53.1,53.8-53.1,141.5,0,195.3l204.7,207.4v.1c6.1,6.3,16.2,6.4,22.5.3,0,0,.2-.2.3-.3l204.7-207.4c53.1-53.8,53.1-141.4,0-195.3ZM449.22,213.6l-193.3,195.9L62.63,213.5c-40.9-41.4-40.9-108.9,0-150.3,19.5-19.9,46.1-31.1,73.9-31,27.9,0,54.1,11,73.9,31l34.1,34.6c6.4,6.1,16.4,6.1,22.8,0l34.1-34.6c19.5-19.9,46.1-31,73.9-31s54.4,11.2,73.9,31c40.9,41.5,40.9,108.9,0,150.4Z"
    />
    <path
      fill="#ff2f40"
      d="M449.22,213.6l-193.3,195.9L62.63,213.5c-40.9-41.4-40.9-108.9,0-150.3,19.5-19.9,46.1-31.1,73.9-31,27.9,0,54.1,11,73.9,31l34.1,34.6c6.4,6.1,16.4,6.1,22.8,0l34.1-34.6c19.5-19.9,46.1-31,73.9-31s54.4,11.2,73.9,31c40.9,41.5,40.9,108.9,0,150.4Z"
    />
  </svg>
)
